function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import React from 'react';
import { useParaglideLocale } from '../hooks/useParaglideLocale';
import { Button, ButtonGroup, Tooltip, Dropdown, DropdownTrigger, DropdownMenu, DropdownItem } from '@heroui/react';
import { Globe, ChevronDown } from 'lucide-react';
import { LAYOUT_BREAKPOINTS } from '@edusense/shared-constants';
var languages = [
    {
        code: 'ko',
        name: 'Korean',
        nativeName: '한국어',
        flag: '🇰🇷'
    },
    {
        code: 'en',
        name: 'English',
        nativeName: 'English',
        flag: '🇺🇸'
    },
    {
        code: 'ja',
        name: 'Japanese',
        nativeName: '日本語',
        flag: '🇯🇵'
    }
];
/**
 * 언어 선택기 컴포넌트
 * 
 * @example
 * ```tsx
 * import { LanguageSelector } from '@edusense/i18n';
 * 
 * <LanguageSelector 
 *   variant="dropdown"
 *   showFlag={true}
 *   onLanguageChange={(lang) => console.log('Language changed to:', lang)}
 * />
 * ```
 */ export var LanguageSelector = function(param) {
    var _param_variant = param.variant, variant = _param_variant === void 0 ? 'dropdown' : _param_variant, _param_showNativeName = param.showNativeName, showNativeName = _param_showNativeName === void 0 ? true : _param_showNativeName, _param_showFlag = param.showFlag, showFlag = _param_showFlag === void 0 ? true : _param_showFlag, _param_className = param.className, className = _param_className === void 0 ? '' : _param_className, onLanguageChange = param.onLanguageChange, _param_responsive = param.responsive, responsive = _param_responsive === void 0 ? true : _param_responsive;
    var _useParaglideLocale = useParaglideLocale(), currentLocale = _useParaglideLocale.currentLocale, changeLocale = _useParaglideLocale.changeLocale, availableLocales = _useParaglideLocale.availableLocales;
    var currentLanguage = currentLocale.split('-')[0];
    console.log("\uD83C\uDF10 [LanguageSelector] Render:", {
        currentLocale: currentLocale,
        currentLanguage: currentLanguage,
        availableLocales: availableLocales,
        variant: variant,
        responsive: responsive
    });
    // Initialize isMobile correctly to prevent race condition in Tauri WebView
    var _React_useState = _sliced_to_array(React.useState(function() {
        if (typeof window !== 'undefined') {
            return window.innerWidth < LAYOUT_BREAKPOINTS.TABLET_MIN;
        }
        return false;
    }), 2), isMobile = _React_useState[0], setIsMobile = _React_useState[1];
    // Track when component is mounted to avoid SSR/CSR mismatch
    var _React_useState1 = _sliced_to_array(React.useState(false), 2), isMounted = _React_useState1[0], setIsMounted = _React_useState1[1];
    // State for dropdown - removed unused state
    // const [isOpen, setIsOpen] = React.useState(false);
    React.useEffect(function() {
        setIsMounted(true);
        var checkMobile = function() {
            setIsMobile(window.innerWidth < LAYOUT_BREAKPOINTS.TABLET_MIN);
        };
        checkMobile();
        window.addEventListener('resize', checkMobile);
        return function() {
            return window.removeEventListener('resize', checkMobile);
        };
    }, []);
    var handleLanguageChange = function(langCode) {
        if (langCode && langCode !== currentLanguage) {
            console.log("\uD83C\uDF10 [LanguageSelector] Changing language: ".concat(currentLanguage, " → ").concat(langCode));
            // 1. Paraglide locale 변경
            changeLocale(langCode);
            // 2. URL 경로 계산
            var currentPath = window.location.pathname;
            var pathParts = currentPath.split('/');
            var newPath;
            // 언어 코드가 경로에 있는지 확인 (예: /ko/home, /en/courses)
            if (pathParts.length > 1 && availableLocales.includes(pathParts[1])) {
                pathParts[1] = langCode;
                newPath = pathParts.join('/');
            } else {
                // 언어 prefix가 없는 경우 추가
                newPath = "/".concat(langCode).concat(currentPath);
            }
            console.log("\uD83D\uDD04 [LanguageSelector] Navigating: ".concat(currentPath, " → ").concat(newPath));
            // 3. 🚀 React Router 호환 방식: 커스텀 이벤트로 네비게이션 요청
            var navigationEvent = new CustomEvent('language-navigation', {
                detail: {
                    newPath: newPath,
                    langCode: langCode,
                    search: window.location.search,
                    hash: window.location.hash
                }
            });
            window.dispatchEvent(navigationEvent);
            // 4. 콜백으로 상위 컴포넌트에 네비게이션 위임
            if (onLanguageChange) {
                onLanguageChange(langCode, newPath);
            } else {
                // 🔧 폴백: History API (React Router가 감지 가능)
                console.log("\uD83D\uDD27 [LanguageSelector] Using history.pushState fallback");
                window.history.pushState({}, '', newPath + window.location.search + window.location.hash);
                // React Router가 감지하도록 popstate 이벤트 트리거
                window.dispatchEvent(new PopStateEvent('popstate', {
                    state: {}
                }));
            }
        }
    };
    // If not mounted yet, return a placeholder to avoid SSR/CSR mismatch
    if (!isMounted) {
        return /*#__PURE__*/ React.createElement("div", {
            className: "flex gap-1 ".concat(className)
        }, languages.map(function(lang) {
            return /*#__PURE__*/ React.createElement(Button, {
                key: lang.code,
                isIconOnly: true,
                size: "sm",
                variant: currentLanguage === lang.code ? 'solid' : 'flat',
                color: currentLanguage === lang.code ? 'primary' : 'default',
                className: "text-lg min-w-[44px] w-[44px] h-[44px]",
                disabled: true
            }, lang.flag);
        }));
    }
    // For mobile responsive mode with flags variant
    if (responsive && isMobile && variant === 'flags') {
        return /*#__PURE__*/ React.createElement("div", {
            className: "flex gap-1 ".concat(className)
        }, languages.map(function(lang) {
            return /*#__PURE__*/ React.createElement(Button, {
                key: lang.code,
                isIconOnly: true,
                size: "sm",
                variant: currentLanguage === lang.code ? 'solid' : 'flat',
                color: currentLanguage === lang.code ? 'primary' : 'default',
                onPress: function() {
                    return handleLanguageChange(lang.code);
                },
                "aria-label": "Switch to ".concat(lang.name),
                "aria-current": currentLanguage === lang.code ? 'true' : 'false',
                className: "text-lg min-w-[44px] w-[44px] h-[44px]"
            }, lang.flag);
        }));
    }
    // Dropdown 변형 - Using HeroUI Dropdown for better stability
    if (variant === 'dropdown') {
        var currentLang = languages.find(function(l) {
            return l.code === currentLanguage;
        });
        // Responsive button size and content
        var buttonSize = responsive && isMobile ? "sm" : "md";
        var iconSize = responsive && isMobile ? 14 : 16;
        var minWidth = responsive && isMobile ? "min-w-[100px]" : "min-w-[150px]";
        return /*#__PURE__*/ React.createElement(Dropdown, {
            className: className
        }, /*#__PURE__*/ React.createElement(DropdownTrigger, null, /*#__PURE__*/ React.createElement(Button, {
            variant: "flat",
            size: buttonSize,
            className: "".concat(minWidth, " justify-between"),
            startContent: responsive && isMobile ? null : /*#__PURE__*/ React.createElement(Globe, {
                size: iconSize
            }),
            endContent: /*#__PURE__*/ React.createElement(ChevronDown, {
                size: iconSize
            }),
            "aria-label": "Language selector"
        }, /*#__PURE__*/ React.createElement("div", {
            className: "flex items-center gap-1.5"
        }, showFlag && currentLang && /*#__PURE__*/ React.createElement("span", {
            className: responsive && isMobile ? "text-base" : ""
        }, currentLang.flag), /*#__PURE__*/ React.createElement("span", {
            className: responsive && isMobile ? "text-sm" : ""
        }, responsive && isMobile && currentLang ? currentLang.code.toUpperCase() : (currentLang === null || currentLang === void 0 ? void 0 : currentLang.nativeName) || 'Select Language')))), /*#__PURE__*/ React.createElement(DropdownMenu, {
            "aria-label": "Language selection",
            selectedKeys: [
                currentLanguage
            ],
            selectionMode: "single",
            onSelectionChange: function(keys) {
                var selectedKey = Array.from(keys)[0];
                if (selectedKey) {
                    handleLanguageChange(selectedKey);
                }
            }
        }, languages.map(function(lang) {
            return /*#__PURE__*/ React.createElement(DropdownItem, {
                key: lang.code,
                startContent: showFlag ? /*#__PURE__*/ React.createElement("span", {
                    className: responsive && isMobile ? "text-base" : "text-lg"
                }, lang.flag) : undefined,
                className: responsive && isMobile ? "py-1.5" : ""
            }, /*#__PURE__*/ React.createElement("span", {
                className: responsive && isMobile ? "text-sm" : ""
            }, responsive && isMobile ? lang.code.toUpperCase() : showNativeName ? lang.nativeName : lang.name));
        })));
    }
    // Buttons 변형
    if (variant === 'buttons') {
        return /*#__PURE__*/ React.createElement(ButtonGroup, {
            className: className,
            variant: "flat",
            color: "default"
        }, languages.map(function(lang) {
            return /*#__PURE__*/ React.createElement(Button, {
                key: lang.code,
                onPress: function() {
                    return handleLanguageChange(lang.code);
                },
                color: currentLanguage === lang.code ? 'primary' : 'default',
                variant: currentLanguage === lang.code ? 'solid' : 'flat',
                "aria-label": "Switch to ".concat(lang.name),
                "aria-current": currentLanguage === lang.code ? 'true' : 'false',
                startContent: showFlag ? /*#__PURE__*/ React.createElement("span", null, lang.flag) : undefined
            }, showNativeName ? lang.nativeName : lang.name);
        }));
    }
    // Flags 변형
    return /*#__PURE__*/ React.createElement("div", {
        className: "flex gap-1 ".concat(className)
    }, languages.map(function(lang) {
        return /*#__PURE__*/ React.createElement(Tooltip, {
            key: lang.code,
            content: showNativeName ? lang.nativeName : lang.name,
            placement: "bottom"
        }, /*#__PURE__*/ React.createElement(Button, {
            isIconOnly: true,
            size: "sm",
            variant: currentLanguage === lang.code ? 'solid' : 'flat',
            color: currentLanguage === lang.code ? 'primary' : 'default',
            onPress: function() {
                return handleLanguageChange(lang.code);
            },
            "aria-label": "Switch to ".concat(lang.name),
            "aria-current": currentLanguage === lang.code ? 'true' : 'false',
            className: "text-lg"
        }, lang.flag));
    }));
};
export default LanguageSelector;
